import React, { Component } from 'react'

import CategoriesContent from './CategoriesContent'
import Navbar from 'cms/components/Navbar';
import Mainmenu from 'cms/components/Mainmenu';
import Footer from 'cms/components/Footer';
export default class Categories extends Component {

    

    render() {

        let id = this.props.match.params.id;
        return (
            <div className="wrapper">
                <Navbar />
                <Mainmenu />
                <CategoriesContent id={id} />
                <Footer />

            </div>


        )
    }
}
